import RouteView from '@/layouts/RouteView'

export default {
  path: '/device-mana',
  name: 'Device.Search',
  meta: { icon: 'reconciliation', title: '设备管理', bread: true },
  component: RouteView,
  children: [
    { path: '/device-mana', redirect: '/device-mana/index' },
    {
      path: '/device-mana/index',
      name: 'Device.Search',
      meta: { title: '设备列表', bread: true, hasRouteView: true },
      props: true,
      component: () => import(/* webpackChunkName: 'clientMana' */ '@/views/device-mana/search/index.vue')
    },
    {
      path: '/device-mana/error-log',
      name: 'Device.ErrorLog',
      meta: { title: '设备失败记录查询', bread: true, hasRouteView: true },
      props: true,
      component: () => import(/* webpackChunkName: 'clientMana' */ '@/views/device-mana/error-log/index.vue')
    },
  ],

}
